export enum UserSettingName {
  Locale = 'locale',
  Theme = 'theme',
  DateFormat = 'dateFormat',
  TimeFormat = 'timeFormat',
  SafeMode = 'safeMode',
  HideFloatingNotifications = 'hideFloatingNotifications',
  DeveloperMode = 'developerMode',
  AllowedLlmToolNames = 'allowedLlmToolNames',
  MuteNotificationsWhenBusy = 'muteNotificationsWhenBusy',
  BusyBreakthroughNotificationTypes = 'busyBreakthroughNotificationTypes',
  ProductTourState = 'productTourState',
}
